import type { SetlistContext } from './client';
import { STOCK_VIDEO_CATEGORIES } from './collections';
import type { VideoCategory } from './stock-video-types';
import {
  getCategoryStatusFilter,
  VIDEO_CATEGORY_FIELDS,
} from './stock-video-types';

export const getVideoCategory = async (
  context: SetlistContext,
  slug: string,
  isAdmin = false
): Promise<VideoCategory | null> => {
  const statusFilter = getCategoryStatusFilter(isAdmin);

  const response = await context.client
    .collections(STOCK_VIDEO_CATEGORIES)
    .documents()
    .search(
      {
        q: '*',
        query_by: 'name',
        filter_by: `slug:=${slug} && ${statusFilter}`,
        include_fields: VIDEO_CATEGORY_FIELDS,
        per_page: 1,
      },
      { cacheSearchResultsForSeconds: 60 }
    );

  const hit = response.hits?.at(0);

  if (!hit) {
    return null;
  }

  return hit.document as VideoCategory;
};
